import type { PracticeSettings } from "./types"

const parseHslComponents = (hslColor: string): [number, number, number] => {
  const [h, s, l] = hslColor
    .replace(/%/g, "")
    .split(" ")
    .map((v) => parseInt(v, 10))
  return [h, s, l]
}

const buildHoverHslComponents = (hslComponents: string): string | undefined => {
  const match = hslComponents.match(/^(\d+)deg\s+(\d+)%\s+(\d+)%$/)
  if (!match) return undefined

  const h = Number(match[1])
  const s = Number(match[2])
  const l = Number(match[3])

  const newS = s - 7
  const newL = l > 20 ? l - 7 : l - 3

  return `${h}deg ${newS}% ${newL}%`
}

const applyThemeColor = (colorName: string, themeColor?: string) => {
  document.body.style.setProperty(`--color-${colorName}`, themeColor || "")

  const hover = themeColor ? buildHoverHslComponents(themeColor) : undefined
  document.body.style.setProperty(`--color-${colorName}-hover`, hover || "")
}

const setFavicon = (iconUrl?: string) => {
  if (!iconUrl) return

  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']")
  if (!link) {
    link = document.createElement("link")
    link.rel = "icon"
    document.head.appendChild(link)
  }
  link.href = iconUrl
}

const applyBrandingSettings = (settings: PracticeSettings) => {
  applyThemeColor("primary", settings.primaryColor)
  applyThemeColor("secondary", settings.secondaryColor)
  applyThemeColor("overlay-top-stop", settings.overlayTopStop)
  applyThemeColor("overlay-bottom-stop", settings.overlayBottomStop)

  setFavicon(settings.iconLogo)

  document.title = `${settings.brandName || settings.name} - Patient Portal Registration`
}

export { applyThemeColor, applyBrandingSettings, buildHoverHslComponents, parseHslComponents }
